import initCustomSelects from '../components/initCustomSelects';

document.addEventListener('DOMContentLoaded', () => {

    const { resetCustomSelects } = initCustomSelects();

    const eventRouteSelect = document.getElementById('event-route');
    const agesSelect = document.getElementById('ages_select');
    const categoriesSelect = document.getElementById('categories_select');

    if (!eventRouteSelect || !agesSelect || !categoriesSelect) return;

    const locale = document.documentElement.lang || 'ro';
    const prefix = locale === 'ro' ? '' : `/${locale}`;

    const resetAndDisableSelect = (select) => {
        select.innerHTML = '';
        select.disabled = true;

        resetCustomSelects([select.name]);
    };

    const updateSelectOptions = (select, options) => {
        select.innerHTML = '';

        options.forEach(item => {
            const opt = document.createElement('option');
            opt.value = item.id;
            opt.textContent = item.name;
            select.appendChild(opt);
        });

        select.disabled = false;
        resetCustomSelects([select.name]);
    };

    // const priceBlock = document.getElementById('route-price-block');
    const priceValue = document.querySelector('[data-route-price]');
    const disclaimerBlock = document.querySelector('[data-disclaimer-block]');

    eventRouteSelect.addEventListener('change', async function () {
        const routeId = this.value;

        if (!routeId) {
            resetAndDisableSelect(agesSelect);
            resetAndDisableSelect(categoriesSelect);
            return;
        }

        try {
            const res = await fetch(`${prefix}/event-route/${routeId}`);
            const data = await res.json();

            updateSelectOptions(agesSelect, data.ages);
            updateSelectOptions(categoriesSelect, data.categories);

            if (data.price && data.price.value) {
                priceValue.textContent = data.price.value;
                disclaimerBlock.classList.add('hidden');
                // priceBlock.classList.remove('hidden');
            }

        } catch (e) {
            console.error('Route fetch error', e);
        }
    });

    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-toggle-modal][data-target-modal="#dialog--login"]');
        if (!btn) return;

        const redirectInput = document.getElementById('login-redirect');
        if (redirectInput) {
            redirectInput.value = encodeURIComponent(window.location.pathname);
        }
    });

    document.addEventListener('click', (e) => {
        const link = e.target.closest(
            'a[href*="/auth/google"], a[href*="/auth/facebook"]'
        );
        if (!link) return;

        const redirectInput = document.getElementById('login-redirect');
        if (!redirectInput || !redirectInput.value) return;

        const url = new URL(link.href);
        url.searchParams.set('redirect', redirectInput.value);

        link.href = url.toString();
    });
});
